import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const InputTagFilter = ({
	id,
	formField,
	label,
	filtersActive,
	selector,
	fetchAction,
	isTranslated = false,
	translationKey = '',
	freeInput = false,
	valueType = 'string',
	searchKey = 'name',
	multiselect = true,
	placeholder = '',
	filterKey = 'name',
	displayKey = 'name',
}) => {
	const dispatch = useDispatch();
	const [searchQuery, setSearchQuery] = useState('');
	const list = useSelector(selector[0]);
	const [filters, setFilters] = useState([]);
	const dropdownRef = useRef();
	const [isActive, setIsActive] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (searchQuery?.trim()?.length > 0) {
			fetchData();
		}
	}, [searchQuery]);

	useEffect(() => {
		if(formField.value != null && formField.value.length !== filters.length) {
			setFilters(formField.value);
		}
	}, [formField.value]);

	const fetchData = () => {
		if (searchQuery?.trim()?.length > 0) {
			dispatch(
				fetchAction[0]({
					page: 0,
					filter:
						valueType === 'string'
							? `name-like=${searchQuery}`
							: `page=0&size=10&filter=${searchKey}:LIKE_IC:${searchQuery}`,
				})
			);
		} else {
			dispatch(fetchAction[0]({ page: 0, filter: '' }));
		}
	};

	useEffect(() => {
		if (!filtersActive) {
			setIsActive(false);

			setSearchQuery('');
			setFilters([]);
		}
	}, [filtersActive]);

	const setNewItem = (value) => {
		const _filters = [...filters, value];
		setFilters(_filters);
		formField.setValue(_filters);
		setSearchQuery('');
	};

	const removeFilter = (filter) => {
		const _filters = [];
		const _values = [];

		filters.map((item) => {
			if (item !== filter) {
				_filters.push(item);
				_values.push(item[filterKey]);
			}
		});

		formField.setValue(_values);
		setFilters(_filters);
	};

	const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsActive(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const fetchInitialData = () => {
		setIsActive(true);
		if ((list && list.length === 0) || searchQuery?.trim()?.length === 0) {
			fetchData();
		}
	};

	return (
		<div>
			<label htmlFor={id} className="py-2">
				{label}
			</label>
			<div
				ref={dropdownRef}
				className={`input-tag-container ${
					multiselect ? 'input-tag-container-multiselect' : ''
				}`}>
				<div className="input-tags">
					{filters &&
						filters.length > 0 &&
						filters.map((filter, index) => (
							<div key={index} className="input-tag">
								<span>
									{isTranslated
										? t(translationKey + '.' + filter[displayKey])
										: filter[displayKey]}
								</span>
								<i
									className="icon fz fz-times"
									onClick={() => {
										removeFilter(filter);
									}}
								/>
							</div>
						))}
				</div>
				<div className="dropdown">
					<div className="dropdown-input">
						<input
							id={id}
							type="search"
							className="input"
							value={searchQuery}
							onChange={(e) => {
								if (!isActive && e.target.value?.trim()?.length > 0) {
									setIsActive(true);
								}
								setSearchQuery(e.target.value);
							}}
							onKeyDown={(e) => {
								if (e.keyCode === 13 && freeInput) {
									e.preventDefault();
									e.stopPropagation();
									setNewItem(searchQuery);
								}
							}}
							onFocus={() => fetchInitialData()}
							placeholder={multiselect ? placeholder || label : ''}
						/>
						<i
							className="icon fz-chevron-down"
							onClick={() => fetchInitialData()}
						/>
					</div>
					{isActive && list?.content?.length > 0 && (
						<ul className="dropdown-container scrollbar">
							{list.content
								.filter(
									(item) =>
										!filters.some(
											(filterItem) =>
												filterItem?.[displayKey] === item?.[displayKey] ||
												filterItem === item?.[displayKey]
										)
								)
								.map((item) => (
									<li
										key={item.code}
										onClick={() => {
											setNewItem(item);
										}}>
										{isTranslated
											? t(translationKey + '.' + item[displayKey])
											: item[displayKey]}
									</li>
								))}
						</ul>
					)}
				</div>
			</div>
		</div>
	);
};

export default InputTagFilter;
